import React from 'react'
import { createRoot } from 'react-dom/client'
import { Loading } from './loading'
import clsx from 'clsx'

let root: ReturnType<typeof createRoot> | null = null

/**
 * @function showGlobalLoading
 * @description This method renders a loading circle on the screen
 */
export const showGlobalLoading = (loadingClassname?: string) => {
  const container = document.getElementById('fullscreenloading')
  if (!container) return

  if (!root) {
    root = createRoot(container)
  }

  root.render(
    <div>
      <Loading className={clsx(loadingClassname || 'w-[8rem] h-[8rem]')} />
    </div>
  )
}

/**
 * @function hideGlobalLoading
 * @description This method hides the loading circle on the screen
 */
export const hideGlobalLoading = () => {
  if (root) {
    root.unmount()
    root = null
  }
}
